import { Amplify } from 'aws-amplify';
import { appConfig } from 'shared/appConfig';

Amplify.configure({
  auth: {
    aws_region: appConfig.cognito.region,
    user_pool_id: appConfig.cognito.userPoolId,
    user_pool_client_id: appConfig.cognito.clientId,
    authentication_flow_type: 'CUSTOM_AUTH',
  },
  Auth: {
    Cognito: {
      userPoolId: appConfig.cognito.userPoolId,
      userPoolClientId: appConfig.cognito.clientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: appConfig.cognito.domain,
          scopes: ['profile', 'email', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [appConfig.cognito.redirectSignIn],
          redirectSignOut: [appConfig.cognito.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
});
